import http from '@/utils/http';
import axios from 'axios';

const URL_BASE = '/ar/pessoa';

export default {
    buscarPessoaRegistradaPorDocumento(documento) {
        return http.get({
            url: `${URL_BASE}/documento/${documento}`,
            lockScreen: false
        });
    },

    cadastrarViaPlanilha(planilha) {
        const url = process.env.VUE_APP_HTTP_PATH +
                  URL_BASE +
                  '/inserir-planilha';

        const formData = new FormData();
        formData.append('planilha', planilha.raw);

        return axios.post(
            url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    buscarDadosLoteCadastroViaPlanilha() {
        return http.get({
            url: URL_BASE + '/lote',
            lockScreen: false
        });
    },

    downloadPlanilhaComErro(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: URL_BASE + `/lote/download-planilha-erro/${id}`,
                    responseType: 'blob',
                    lockScreen: false
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    buscarResultadoLote({ pagina, ordenacao, tamanho }) {
        return http.get({
            url: `${URL_BASE}/processamento/pessoas/resultado?page=${
                    pagina - 1
                }&sort=${ordenacao}&size=${tamanho}`,
            lockScreen: false
        });
    },

    cadastrarPessoas(payload) {
        const url = process.env.VUE_APP_HTTP_PATH + URL_BASE + '/cadastrar';
        const jwt = sessionStorage.getItem('jwtToken');
        return axios.post(url, payload, {
            headers: { Authorization: `Bearer ${jwt}` }
        });
    },

    cancelarItensLote(ids) {
        const url = process.env.VUE_APP_HTTP_PATH + URL_BASE + '/lote/itens';
        const jwt = sessionStorage.getItem('jwtToken');
        return axios.delete(url, {
            data: ids,
            headers: { Authorization: `Bearer ${jwt}` }
        });
    },

    confirmarLote(id) {
        return http.post({
            url: `${URL_BASE}/lote/${id}/confirmar`,
            lockScreen: true
        });
    }
};
